export const APP_STORE_URL =
  'https://apps.apple.com/pt/app/ju-financeiro/id6794307381?l=en-GB'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.jufinanceiro.mobile'
